/**
 * Flags
 *
 * @author edmsamuel
 */
export const FLAG_LOCAL_STORAGE_PREFIX = '@ERP2017ProveedoresApp_';
export const FLAG_LOCAL_STORAGE_TOKEN = FLAG_LOCAL_STORAGE_PREFIX + 'Token';
export const FLAG_FORMAT_MONEY = '$ 0,0.00';
